export interface SignatureFont {
  id: string;
  name: string;
  fontFamily: string;
  displayName: string;
}

export const signatureFonts: SignatureFont[] = [
  { id: 'journal', name: 'Journal', fontFamily: 'Journal', displayName: 'Journal' },
  { id: 'mulder-hw', name: 'Mulder Handwriting', fontFamily: 'MulderHW', displayName: 'Mulder' },
  { id: 'phontphreaks', name: 'PhontPhreaks', fontFamily: 'PhontPhreaks', displayName: 'PhontPhreaks' },
  { id: 'vntfap', name: 'Vntfap', fontFamily: 'Vntfap', displayName: 'Vntfap' },
  { id: 'lynnspf', name: 'Lynn SPF', fontFamily: 'LynnSPF', displayName: 'Lynn' },
  { id: 'nathaniel', name: 'Nathaniel', fontFamily: 'Nathaniel', displayName: 'Nathaniel' },
  { id: 'lunabar', name: 'Lunabar', fontFamily: 'Lunabar', displayName: 'Lunabar' },
  { id: 'chuang', name: 'Chuang', fontFamily: 'Chuang', displayName: 'Chuang' },
  { id: 'comesinhandy', name: 'Comes In Handy', fontFamily: 'ComesInHandy', displayName: 'Comes In Handy' },
  { id: 'jerry-b4s', name: "Jerry B4's", fontFamily: 'JerryB4s', displayName: "Jerry's" },
  { id: 'cuttyfruty', name: 'Cutty Fruty', fontFamily: 'CuttyFruty', displayName: 'Cutty Fruty' },
  { id: 'angelina', name: 'Angelina', fontFamily: 'Angelina', displayName: 'Angelina' },
  { id: 'casmira', name: 'Casmira', fontFamily: 'Casmira', displayName: 'Casmira' },
  // Google Fonts (self-hosted for GDPR/DSGVO compliance)
  { id: 'caveat', name: 'Caveat', fontFamily: 'Caveat', displayName: 'Caveat' },
  { id: 'sacramento', name: 'Sacramento', fontFamily: 'Sacramento', displayName: 'Sacramento' },
  { id: 'homemade-apple', name: 'Homemade Apple', fontFamily: 'HomemadeApple', displayName: 'Homemade Apple' },
  { id: 'kalam', name: 'Kalam', fontFamily: 'Kalam', displayName: 'Kalam' },
  { id: 'mrs-saint-delafield', name: 'Mrs Saint Delafield', fontFamily: 'MrsSaintDelafield', displayName: 'Mrs Saint Delafield' },
];

export const getSignatureFontById = (id: string): SignatureFont | undefined => {
  return signatureFonts.find(f => f.id === id);
};
